module.exports = __webpack_public_path__ + "img/hair_back_female_frizzy_medium.908c4d8c.png";